type EditableUserField = 'name' | 'email' | 'phone' | 'pin';

export const EditableUserFields = {
  name: 'name' as EditableUserField,
  email: 'email' as EditableUserField,
  phone: 'phone' as EditableUserField,
  pin: 'pin' as EditableUserField,
};
